// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2EnrollmentModel {
    static getAttributeTypeMap() {
        return EnrollmentV2EnrollmentModel.attributeTypeMap;
    }
}
EnrollmentV2EnrollmentModel.discriminator = undefined;
EnrollmentV2EnrollmentModel.additionalProperties = false;
EnrollmentV2EnrollmentModel.attributeTypeMap = [
    {
        "name": "status",
        "baseName": "status",
        "type": "EnrollmentV2EligibilityModel"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "maxBenefitAmount",
        "baseName": "maxBenefitAmount",
        "type": "number"
    },
    {
        "name": "updateCaseIds",
        "baseName": "updateCaseIds",
        "type": "Array<number>"
    },
    {
        "name": "caseId",
        "baseName": "caseId",
        "type": "number"
    },
    {
        "name": "untrackedBenefit",
        "baseName": "untrackedBenefit",
        "type": "boolean"
    },
    {
        "name": "lastOneOrMoreDays",
        "baseName": "lastOneOrMoreDays",
        "type": "boolean"
    },
    {
        "name": "memberNumbers",
        "baseName": "memberNumbers",
        "type": "Array<EnrollmentV2MemberNumberModel>"
    },
    {
        "name": "enrollmentFlags",
        "baseName": "enrollmentFlags",
        "type": "EnrollmentV2EnrollmentFlags"
    },
    {
        "name": "linkedEntities",
        "baseName": "linkedEntities",
        "type": "EnrollmentCaseRelationshipsModel"
    },
    {
        "name": "householdSize",
        "baseName": "householdSize",
        "type": "number"
    },
    {
        "name": "caseSourceId",
        "baseName": "caseSourceId",
        "type": "number"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "isOpen",
        "baseName": "isOpen",
        "type": "boolean"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "createDate",
        "baseName": "createDate",
        "type": "Date"
    },
    {
        "name": "claimEligibilityDate",
        "baseName": "claimEligibilityDate",
        "type": "Date"
    },
    {
        "name": "caseInitiatorId",
        "baseName": "caseInitiatorId",
        "type": "number"
    },
    {
        "name": "paymentType",
        "baseName": "paymentType",
        "type": "number"
    },
    {
        "name": "conditionTypeCodeList",
        "baseName": "conditionTypeCodeList",
        "type": "Array<string>"
    },
    {
        "name": "isOptedIn",
        "baseName": "isOptedIn",
        "type": "boolean"
    },
    {
        "name": "isQueued",
        "baseName": "isQueued",
        "type": "boolean"
    },
    {
        "name": "benefitPeriodId",
        "baseName": "benefitPeriodId",
        "type": "number"
    },
    {
        "name": "caseSubStatusCode",
        "baseName": "caseSubStatusCode",
        "type": "string"
    },
    {
        "name": "caseStatusCode",
        "baseName": "caseStatusCode",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentV2EnrollmentModel.js.map